import { Component, OnInit, Input, ContentChild, TemplateRef } from '@angular/core';

@Component({
    selector: 'bw-section-card-legacy',
    templateUrl: './section-card.component.html',
    styleUrls: ['./section-card.component.scss'],
    standalone: false
})
export class SectionCardComponentLegacy implements OnInit {
  @Input() header: string;
  @Input() borderType: 'solid' | 'shadow-box' = 'shadow-box';
  /** When true, adds 1rem padding to the top of the section-card__wrapper. Off by default. */
  @Input() wrapperPaddingTop = false;

  @ContentChild('wrappedContent') wrappedContentTemplate: TemplateRef<any>;
  @ContentChild('footerContent') footerContentTemplate: TemplateRef<any>;
  @ContentChild('altContent') altContentTemplate: TemplateRef<any>;

  constructor() {}

  ngOnInit(): void { }
}
